// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"BrowseExtChild\"] {\r\n\tposition: relative;\r\n\tpadding: 0px 5px;\r\n}", ""]);
// Exports
module.exports = exports;
